import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Projects from './components/Projects';
import Skills from './components/Skills';
import About from './components/About';
import Contact from './components/Contact';

function App() {
  return (
    <>
      {/* Background effects */}
      <div className="bg-orb bg-orb-1"></div>
      <div className="bg-orb bg-orb-2"></div>

      <div className="container">
        <Navbar />
        <Hero />
        <Projects />
        <Skills />
        <About />
        <Contact />
      </div>
    </>
  );
}

export default App;
